// 화면 폭 기준을 한 곳에 둔다.
//
// 여기저기서 768 / 1024 를 손으로 적으면 한 곳만 고쳤을 때 헤더는 좁은 화면이고
// 사이드바는 넓은 화면인 어중간한 폭이 생긴다. 실제로 그래서 사이드바가
// 본문 위에 겹쳐 보였다.
//
// lg 가 진짜 경계다. 이 아래에서는 사이드바가 서랍(drawer)이 되고 헤더에
// 햄버거가 나온다. 그 위에서는 사이드바가 본문 옆의 한 칸을 차지한다.

export const bp = {
  sm: 480,   // 좁은 폰
  md: 768,   // 폰 ↔ 태블릿
  lg: 1024,  // 서랍 ↔ 고정 사이드바
  xl: 1280,  // 본문 최대폭
};

/** `${media.md} { ... }` 로 쓴다. 전부 max-width(그 폭 이하) 기준이다. */
export const media = {
  sm: `@media (max-width: ${bp.sm}px)`,
  md: `@media (max-width: ${bp.md}px)`,
  lg: `@media (max-width: ${bp.lg}px)`,
  xl: `@media (max-width: ${bp.xl}px)`,
  /** 사이드바가 본문 옆에 서는 폭. 서랍 스타일을 되돌릴 때 쓴다. */
  wide: `@media (min-width: ${bp.lg + 1}px)`,
  /** 손가락으로 미는 화면. 화살표 버튼을 숨긴다. */
  touch: '@media (hover: none)',
};

export default media;
